/**
 * @generated SignedSource<<dac2cb1d6da74b1ba2b08cd886cffa59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakeOfferButton_item$data = {
  readonly isPrivateVisibilityType: boolean | null;
  readonly makeOfferVpvParams?: any | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item" | "actionButtonsTracking_item">;
  readonly " $fragmentType": "PdpSharedMakeOfferButton_item";
};
export type PdpSharedMakeOfferButton_item$key = {
  readonly " $data"?: PdpSharedMakeOfferButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "defaultValue": "pdp",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v1 = {
  "kind": "RootArgument",
  "name": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmounts",
    "kind": "LinkedField",
    "name": "convertedAmounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "USD",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "pageDisplayEnum"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "actionButtonsTracking_item",
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vertical",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPricing",
          "kind": "LinkedField",
          "name": "pricing",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "totalAmount",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAuctionEnabled",
          "storageKey": null
        },
        {
          "condition": "fetchAuction",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "AuctionSolution",
              "kind": "LinkedField",
              "name": "relevantAuctionSolution",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuctionBidsConnection",
                  "kind": "LinkedField",
                  "name": "bids",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalResults",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "highestBidAmount",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "AuctionLot",
              "kind": "LinkedField",
              "name": "relevantAuctionLot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "buyItNowPrice",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                }
              ],
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "lastTransaction",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Offer",
                  "kind": "LinkedField",
                  "name": "secondChanceOffer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "kind": "LinkedField",
                      "name": "amountPerItem",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "args": [
        {
          "kind": "Variable",
          "name": "fetchAuction",
          "variableName": "fetchAuction"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        }
      ],
      "argumentDefinitions": [
        {
          "defaultValue": null,
          "kind": "LocalArgument",
          "name": "fetchAuction"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "makeOfferVpvParams",
          "args": [
            {
              "kind": "Literal",
              "name": "excludedPurchaseStatuses",
              "value": [
                "RET",
                "CUST"
              ]
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "pdpTrackingVpvParams",
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateVisibilityType",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "4ea185c174c94a92e77374601bc76e4f";

export default node;
